export default {
  nav: {
    home: 'Home',
    aboutUs: 'About Us',
    facilities: 'Facilities',
    certification: 'Certification',
    portofolio: 'Portfolio',
    service: 'Service',
    career: 'Career',
    newsBlog: 'News & Blog',
    factoryTour: 'Factory Tour',
    seminar: 'Seminar',
    contactUs: 'Contact Us',
  },
  footer: {
    copyright: 'PT. TOKKI ENGINEERING AND FABRICATION',
  },
  languageSwitcher: {
    label: 'Language',
    id: 'Indonesian',
    en: 'English',
    ja: 'Japanese',
  },
  offices: {
    motoStartWithTokki: 'with TOKKI',
    mainOfficeFactory: 'Main Office & Factory',
    secondOfficeFactory: '2nd Office & Factory',
    thirdOfficeFactory: '3rd Office & Factory',
    fourthMarketingOffice: '4th Representative Office',
    readMore: 'Read more',
    ourHappyClient: 'Our Happy Client',
    majorCustomerIn: 'Major Customer in',
    productServices: 'Product / Services',
  },
};
